<template>
  <p>正在打开面试邀请收件箱…</p>
</template>

<script>
export default {
  name: 'InterviewInbox',
  mounted () {
    const base = new URL(process.env.BASE_URL, window.location.origin)
    window.location.replace(new URL('interview-inbox/index.html', base).href)
  },
}
</script>
